import { Injectable } from '@angular/core';
import { DataSourceRequestState, DataResult, SortDescriptor, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PriceBookService {

  constructor(    
    private httpRepo:HttpRepo,
    private auth:AuthService    
  ) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
   }

  public fetchPriceBookItems(pricebookListData:any,state: DataSourceRequestState, sort:SortDescriptor[]): Observable<DataResult> 
  {
    const hasGroups = state.group && state.group.length;
    return of({data: pricebookListData.Data,total:pricebookListData.Count}) // Send the state to the server
        .map(({data, total} : GridDataResult) => // Process the response
            (<GridDataResult>{
                data: hasGroups ? translateDataSourceResultGroups(data) : data,
                total: total,
            })
        )
  }
  // // GET price book items
  GetPriceBookItems(state:DataSourceRequestState, searchKey:string){
    return this.httpRepo.Get("pricebook", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
  }
}

